import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from '@/i18n';
import vco from "v-click-outside"
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuelidate from 'vuelidate'
import store from '@/state/store';
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment-timezone';
import * as filters from './filters';
import _ from 'lodash';
import { ToastPlugin } from 'bootstrap-vue'
import * as helpers from '@/helpers/common';
import http from '@/services/http';
import Constant from '@/configs/constant.js';
import common from "@/locales/ja/common";
moment.tz.setDefault('Asia/Tokyo');
import 'vue2-datepicker/index.css';
import "@/assets/scss/app.scss";
import * as rules from 'vee-validate/dist/rules';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import 'vue2-datepicker/locale/ja';
import  CKEditor  from '@ckeditor/ckeditor5-vue2';
import Editor from 'ckeditor5-custom-build';
import ckeditor from './configs/ckeditor';
import '@/assets/scss/ckeditor5.css';

Vue.prototype.$moment = moment;
Vue.prototype.$constant = Constant;
Vue.prototype.$lang = common;
Vue.prototype.$helpers = helpers;
Vue.prototype.$http = http;
Vue.prototype.$ckeditor = {
  editor: Editor,
  editorData: '',
  editorConfig: {
    toolbar: ckeditor.toolbar
  }
};
Vue.prototype.$_ = _;
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.use(vco)
  .use(CKEditor)
  .use(ToastPlugin)
Object.keys(filters).forEach(key => { Vue.filter(key, filters[key]); });
Vue.config.productionTip = false

// install for veevalidate
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.directive('emptyIfNegativeInt', {
  bind: function (el, binding, vnode) {
    el.addEventListener('input', function () {

      let value = parseInt(el.value);
      if (isNaN(value) || value < 0) {
        el.value = '';
      } else {
        el.value = parseInt(value);
      }
    });
  }
});
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
